import type { TimeTrackingEntry } from '@/entities/time-tracking/time-tracking.entity';
import type { UserRole } from '@/entities/auth/user-role.enum';
import { Service } from './http-service';
import type {
  ClockInDto,
  ClockOutDto,
  LocationDto,
  ValidateLocationResponseDto,
} from '@carvia/ros-client-types';

export interface GetActiveTimeTrackingEntriesQuery {
  role?: UserRole[];
}

class TimeTrackingService extends Service {
  async getActiveEntries(query?: GetActiveTimeTrackingEntriesQuery) {
    const res = await this.httpClient.get<TimeTrackingEntry[]>(`${this.endpoint}/active-entries`, {
      params: {
        ...query,
      },
    });
    return res.data;
  }

  async getMyActiveEntry() {
    const res = await this.httpClient.get<TimeTrackingEntry | null>(
      `${this.endpoint}/active-entry/me`,
    );
    return res.data;
  }

  async clockOutMyActiveEntry(dto: ClockOutDto) {
    const res = await this.httpClient.post<{ clockedOut: boolean }>(
      `${this.endpoint}/active-entry/me/clock-out`,
      dto,
    );
    return res.data;
  }

  async clockInMyActiveEntry(dto: ClockInDto) {
    const res = await this.httpClient.post<{ clockedIn: boolean }>(
      `${this.endpoint}/active-entry/me/clock-in`,
      dto,
    );
    return res.data;
  }

  async validateLocation(dto: LocationDto) {
    const res = await this.httpClient.post<ValidateLocationResponseDto>(
      `${this.endpoint}/validate-location`,
      dto,
    );
    return res.data;
  }
}

export const timeTrackingService = new TimeTrackingService('/time-tracking');
